import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../theme';

const Heading = ({ className, componentType = 'h1', children, ...restProps }) => {
	const ComponentType = componentType;
	return <ComponentType className={className} {...restProps}>{children}</ComponentType>
};

Heading.propTypes = {
	className: PropTypes.string,
	componentType: PropTypes.string,
	children: PropTypes.node
};

const StyledHeading = styled(Heading)`
	margin: ${theme.typography.heading.margin};
	font-weight: ${theme.typography.heading.fontWeight};
	line-height: ${theme.typography.heading.lineHeight};
	color: ${theme.typography.heading.color};
`;

export default StyledHeading;
